import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {AuthWrapper} from "../pages/Auth/AuthWrapper";
import {useAuth} from "../contexts/AuthContext";
import {PrivateRoutes} from "./PrivateRoutes";
import Error404 from "../pages/Exception/Error404";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const AppRoutes: React.FC = () => {
  const {currentUser, twoFactorStep} = useAuth();

  // If 2FA step is active, redirect to the appropriate 2FA page
  if (twoFactorStep === 'verify') {
    return (
      <Routes>
        <Route path="/auth/*" element={<AuthWrapper/>}/>
        <Route path="*" element={<Navigate to="/auth/verify-2fa" replace/>}/>
      </Routes>
    );
  }

  if (twoFactorStep === 'setup') {
    return (
      <Routes>
        <Route path="/auth/*" element={<AuthWrapper/>}/>
        <Route path="*" element={<Navigate to="/auth/setup-2fa" replace/>}/>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/auth/*" element={<AuthWrapper/>}/>

      <Route path='/404' element={<Error404/>}/>

      <Route path="/*" element={currentUser ? <PrivateRoutes/> : <Navigate to="/auth/login" replace/>}/>
      <Route index element={currentUser ? <Navigate to='/accueil' replace/> : <Navigate to='/auth/login' replace/>}/>
    </Routes>
  )
}

export {AppRoutes}
